import styled from 'styled-components'

export const buttonStyle = {
  position: 'absolute',
  bottom: '10px',
  left: '50%',
  transform: 'translateX(-50%)',
  padding: '10px 20px',
  fontSize: '16px',
  backgroundColor: '#FFFFFFE5',
  color: 'black',
  border: 'none',
  cursor: 'pointer',
  borderRadius: ' 22.5px',
  width: '86px',
  height: '31px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}
export const containerStyle = {
  position: 'relative',
  width: '100%',
  maxWidth: '1544px',
}

export const CloseBannerContainer = styled('div')(() => ({
  background: 'rgb(255, 255, 255)',
  position: 'absolute',
  width: '20px',
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '20px',
  cursor: 'pointer',
  right: 10,
  top: 10,
}))
